import React, { useRef, useEffect, useCallback, useState} from 'react';
import TrackComponent from "components/v2/TrackComponent.js";
import OutputNode from "components/pulled/OutputNode.js";
import TrackThumbnail from "components/TrackThumbnail.js";
import {connect} from 'react-redux';
import './track.scss';

const ZTrackComponent = ({track, playing, showSequencer, containerRef}) => { 
    let ref = useRef();
    let className = "ztrack-component";
    if (playing) {
        className += " playing";
    }
    if (!track) {
        return '';
    }
    return (
        <div
          onClick={() => track.sequencerEngine.selectTrack(track.trackNumber)}
          ref={ref} className={className}>
          {showSequencer ? <TrackComponent forceShow={true} scrollContainer={containerRef} track={track}/> : 
           [<TrackThumbnail key={0} track={track} draggable={false}/>,
            <div key={1} className="trigger-indicator"/>]}
        </div>);
}

const mapStateToProps = (state, props) => {
    if (!props.track) {
        return {};
    }
    let ret = {
        showSequencer: props.zobject.attributes["show-sequencer"]
    };
    let trackTriggers = state.tracks.triggers[props.track.trackNumber];
    ret.playing = (trackTriggers && Object.keys(trackTriggers).some(
        t => trackTriggers[t])) ||
        (props.track.notesTriggered && Object.keys(props.track.notesTriggered).length > 0);
    ret.notesTriggered = props.track.notesTriggered;
    return ret;
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZTrackComponent);
